export const whyStatecsCtxP1 = ['At STATECS, we highly value precision, client-centric policy, and commitment to developing medical data that aims to '
+ 'streamline healthcare system processes globally. We provide high-quality services delivered by experienced specialists to meet the FDA standards.',
'Our team believes that science should be used at its best to take healthcare and treatments to the next level. Be it new drugs or medical devices,'
+ ' treatment methods, diagnostic systems, or a fresh approach to a medical problem, we have it all covered.',
];

export const whyStatecsCtxP2 = [
  'We serve some of the most prominent pharmaceutical companies and CROs to provide such services as:',
  '●\tStatistical programming',
  '●\tClinical Data Management',
  '●\tMedical writing',
  '●\tRegulatory affairs',
];

export const whyStatecsCtxP3 = [
  'We invest in top talent to deliver scientifically accurate data that will help build a better healthcare future for generations to come. ',
];

export const ourValuesCtx = ['Patients are at the center of our company’s policy. This is why we consider the reliability and precision of our '
+ 'work to be of crucial importance. A single mistake can lead to unfortunate results for the health of many. '
+ 'We carry out medical data collection and analysis to help you deliver the best therapies to your patients. '];
